import { Injectable } from '@angular/core';
import { environments } from '../../environments/env.production';
import { SghAuth } from '../models';

@Injectable({ providedIn: 'root' })
export class SghPropertyService {
  sghAuth: SghAuth = {
    clientId: environments.sghAuth.clientId,
    clientSecret: '',
    issuer: environments.sghAuth.issuer,
    loginRedirectUri: environments.sghAuth.redirectUri,
    logoutRedirectUri: environments.sghAuth.postLogoutRedirectUri,
    pkce: environments.sghAuth.pkce ? environments.sghAuth.pkce : false,
  };
}
